import { Injectable } from "@angular/core";
import { Router, UrlTree } from "@angular/router";
import { Observable } from "rxjs";

import { Utils } from "@serasa/shared/utils/utils";
import {
  ensureMockSession,
  isMockEnvironment,
} from "@serasa/shared/utils/mock-session.util";
import { AuthService } from "./auth.service";

type activateReturn =
  | Observable<boolean | UrlTree>
  | Promise<boolean | UrlTree>
  | boolean
  | UrlTree;
@Injectable({
  providedIn: "root",
})
export class AuthGuard {
  constructor(
    private readonly _router: Router,
    private readonly _authService: AuthService
  ) {}

  canActivate(): activateReturn {
    if (isMockEnvironment()) {
      ensureMockSession();
      this._authService.loggedIn$.next(true);
      this._authService.termIsAccepted = true;
      return true;
    }

    const accessToken = Utils.getCookie("accessToken");
    if (accessToken) {
      this._authService.loggedIn$.next(true);
      return true;
    }

    this._router.navigate(["forbidden"]);
    return false;
  }
}
